'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var angular = require('angular');
var GridNdReoptPreviewButtonController = function GridNdReoptPreviewButtonController($interval, $scope, $rootScope, restangular, reoptimizationService, FlightAnalysisGridService, momentService, scenarioService, reoptimizationSaveService, reoptPreviewDataUtilsService, saveButtonUtilsService, featureToggleService) {
  var gridPanel = $scope.gridPanelScope;
  var flightManagementGrids = ['inventory-management', 'overbooking-management'];
  var checkStatusInterval;
  $scope.flightSendPermissions = {
    'reopt': 'write',
    'flight-optimization': 'write'
  };
  $scope.data = {
    flightReopt: ''
  };
  $scope.selectedRows = [];
  function isFlightManagementGrid() {
    return flightManagementGrids.indexOf(gridPanel.gridId) > -1;
  }
  function setSelectedRowsOnFlightManagement(selectedRows) {
    if (flightManagementGrids.indexOf(gridPanel.gridId) > -1) {
      return _.size(selectedRows) > 0 ? selectedRows : _.get(gridPanel, 'jqxGridSettings.source.loadedData', []);
    }
    return selectedRows;
  }
  function setSelectedRowsIndexOnFlightManagement(selectedRowIndexes) {
    if (flightManagementGrids.indexOf(gridPanel.gridId) > -1) {
      return _.size(selectedRowIndexes) > 0 ? selectedRowIndexes : _.range(_.size(_.get(gridPanel, 'jqxGridSettings.source.loadedData', [])));
    }
    return selectedRowIndexes;
  }
  $scope.isButtonShown = function () {
    return $scope.isReoptimizeButtonShown || isFlightManagementGrid();
  };
  $scope.onRowSelection = function (selectedRows, selectedRowIndexes) {
    var isScenarioSelected = scenarioService.isScenarioSelected();
    $scope.selectedRows = setSelectedRowsOnFlightManagement(selectedRows);
    $scope.selectedRowIndexes = setSelectedRowsIndexOnFlightManagement(selectedRowIndexes);
    $scope.hasRows = $scope.selectedRows.length > 0;
    reoptPreviewDataUtilsService.updateFlightDetails(gridPanel.reoptPreviewData, gridPanel, $scope.selectedRows);
    $scope.data.flightReopt = $scope.selectedRows.length > 1 ? 'flightSend' : 'reoptPreview';
    if (gridPanel.reoptPreviewData.ndReopt) {
      $scope.isReoptimizeButtonShown = !isScenarioSelected && ($scope.hasRows || !gridPanel.reoptPreviewData.ndReopt.read);
      if ($scope.selectedRows.length && gridPanel.reoptPreviewData.ndReopt.entryKey === $scope.selectedRows[0].entryKey && !gridPanel.reoptPreviewData.ndReopt.success) {
        $scope.selectedRowPreviewRequested = true;
        $scope.data.flightReopt = 'flightSend';
      } else {
        $scope.selectedRowPreviewRequested = false;
      }
    } else {
      $scope.isReoptimizeButtonShown = $scope.hasRows && !isScenarioSelected;
    }
    $scope.showPreview = saveButtonUtilsService.isSingleFlightDepartureDateSelected($scope.selectedRows);
    if ($scope.showPreview) {
      $scope.data.flightReopt = 'reoptPreview';
    }
  };
  $scope.reOptimize = function (sendRequested, previewRequested, scenarioName) {
    return reoptimizationService.reoptimizeNDFromFlightScreen($scope.selectedRows, scenarioName, sendRequested, previewRequested);
  };
  $scope.isReoptPrevMenuItemDisabled = function () {
    return reoptPreviewDataUtilsService.isMdReopt(gridPanel.reoptPreviewData) || reoptPreviewDataUtilsService.isNdReoptSubmitted(gridPanel.reoptPreviewData) || featureToggleService.isEnabled('SERVICE_CLASS_CONTROL');
  };
  $scope.isReoptPrevMenuItemShown = function () {
    return $scope.showPreview && $scope.hasRows;
  };
  $scope.setDefaultRadioButton = function () {
    $scope.data.flightReopt = $scope.isReoptPrevMenuItemShown() && !$scope.isReoptPrevMenuItemDisabled() ? 'reoptPreview' : 'dateReopt';
  };
  $scope.checkPreviewStatus = function () {
    if (reoptPreviewDataUtilsService.isNdReopt(gridPanel.reoptPreviewData)) {
      var departureDate = momentService.copy(gridPanel.reoptPreviewData.ndReopt.flightDepartureDateMoment, momentService.FIELD.ND_DEPARTURE_DATE).toISOString();
      var flightNumber = gridPanel.reoptPreviewData.ndReopt.flightNumber;
      reoptimizationService.getStatus(departureDate, flightNumber, scenarioService.getCurrentUserNDPreviewRequestName()).then(function (response) {
        if (_.isEmpty(response)) {
          return;
        }
        var status = response[0].status;
        if (status === 'ERROR-PROCESSING') {
          $scope.cancelCheckStatusInterval();
          showError('Error occurred during Optimization Processing for Flight Number ' + flightNumber + ' and Departure Date:' + departureDate);
          gridPanel.reoptPreviewData.ndReopt = undefined;
          $scope.data.flightReopt = 'reoptPreview';
        } else if (status === 'FINISHED-PROCESSING' && !!gridPanel.reoptPreviewData.ndReopt) {
          $scope.cancelCheckStatusInterval();
          toastr.success('Reopt preview finished processing');
          gridPanel.reoptPreviewData.ndReopt.success = true;
        }
      });
    } else {
      $scope.cancelCheckStatusInterval();
    }
  };
  $scope.checkPreviewStatusInterval = function () {
    $scope.cancelCheckStatusInterval();
    checkStatusInterval = $interval(function () {
      $scope.checkPreviewStatus();
    }, 2500);
  };
  $scope.checkStatus = function () {
    $scope.setDefaultRadioButton();
    if (gridPanel.reoptPreviewData.ndReopt && !gridPanel.reoptPreviewData.ndReopt.success) {
      $scope.checkPreviewStatusInterval();
    }
  };
  $scope.$on('re-opt:reset:' + gridPanel.gridId, function () {
    if (gridPanel.reoptPreviewData.ndReopt || gridPanel.reoptPreviewData.mdReopt) {
      $scope.getReoptFlight();
    } else {
      $scope.isReoptimizeButtonShown = false;
      gridPanel.reoptPreviewData.ndReopt = undefined;
    }
  });
  $scope.reoptimizeMarketGrid = function () {
    reoptimizationService.reoptimizeFromMarketScreen($scope.selectedRows, scenarioService.getSelectedScenarioName());
  };
  function prepareDataForSaving(scenarioName) {
    var dataForSaving = [];
    _.forEach(gridPanel.reoptPreviewData.flightDetails, function (el) {
      dataForSaving.push({
        data: saveButtonUtilsService.getEditedRowsFromData(el.loadedData),
        gridId: el.gridId,
        selectedRows: el.selectedRows,
        scenarioName: scenarioName,
        previewEnabled: reoptPreviewDataUtilsService.isNdReoptPreview(gridPanel.reoptPreviewData),
        userAction: 'reoptPreview'
      });
    });
    return dataForSaving;
  }
  function submitNDReoptPreview() {
    var scenarioName = scenarioService.NDPreviewRequest;
    var saveDataArray = prepareDataForSaving(scenarioName);
    reoptPreviewDataUtilsService.initNdReopt(gridPanel.reoptPreviewData, $scope.selectedRows[0]);
    $scope.data.flightReopt = 'flightSend';
    toastr.success('Submitting flight reopt preview request');
    reoptimizationSaveService.saveDataBeforeReoptPrev(saveDataArray, scenarioName).then(function () {
      return $scope.reOptimize('N', true, scenarioName);
    }).then(function () {
      $scope.checkPreviewStatusInterval();
    });
  }
  $scope.submitReopt = function () {
    var sendRequested = $scope.data.flightReopt === 'flightNoSend' ? 'N' : 'Y';
    if (gridPanel.reoptPreviewData.ndReopt && !gridPanel.reoptPreviewData.ndReopt.success) {
      return;
    }
    if ($scope.selectedRows.length && $scope.data.flightReopt === 'dateReopt') {
      $rootScope.$broadcast('reoptimizeGrid', gridPanel.gridId, $scope.selectedRows);
    } else if ($scope.showPreview && $scope.data.flightReopt === 'reoptPreview') {
      submitNDReoptPreview();
    } else if ($scope.data.flightReopt !== 'reoptPreview' || $scope.showPreview) {
      $scope.reOptimize(sendRequested, false, $scope.scenarioName);
    } else if ($scope.data.flightReopt !== 'reoptPreview' && !$scope.showPreview) {
      $scope.reOptimize(sendRequested, false, $scope.scenarioName);
    }
  };
  function showError(message) {
    toastr.error(message);
  }
  $scope.getReoptimizedFlight = function () {
    if (reoptPreviewDataUtilsService.isNdReopt(gridPanel.reoptPreviewData)) {
      if (isFlightManagementGrid()) {
        if (reoptPreviewDataUtilsService.isNdReoptPreview(gridPanel.reoptPreviewData)) {
          return;
        }
        _.forEach(gridPanel.reoptPreviewData.gridDetails, function (gridSettings, gridId) {
          FlightAnalysisGridService.updateReoptPreviewRows(gridId, gridSettings, [gridPanel.reoptPreviewData.ndReopt]);
        });
      } else {
        FlightAnalysisGridService.updateReoptPreviewRows(gridPanel.gridId, gridPanel.jqxGridSettings, [gridPanel.reoptPreviewData.ndReopt]);
      }
      gridPanel.reoptPreviewData.ndReopt.read = true;
      $scope.isReoptimizeButtonShown = false;
    }
    angular.element('.toolbar-dropdown-menu').parent().removeClass('open');
  };
  $scope.getMDReoptimizedFlight = function () {
    FlightAnalysisGridService.updateReoptPreviewRows(gridPanel.gridId, gridPanel.jqxGridSettings, undefined);
    angular.element('.toolbar-dropdown-menu').parent().removeClass('open');
  };
  $scope.getReoptFlight = function () {
    if (reoptPreviewDataUtilsService.isMdReoptPreview(gridPanel.reoptPreviewData)) {
      $scope.getMDReoptimizedFlight();
    }
    if (reoptPreviewDataUtilsService.isNdReoptPreview(gridPanel.reoptPreviewData)) {
      $scope.getReoptimizedFlight();
    }
  };
  $scope.$watch('reoptPreviewData.ndReopt.read', function (newVal, oldValue) {
    if (newVal && oldValue !== true) {
      $scope.getReoptFlight();
    }
  });
  $scope.$watch('reoptPreviewData.mdReopt.read', function (newVal, oldValue) {
    if (newVal && oldValue !== true) {
      $scope.getReoptFlight();
    }
  });
  $scope.cancelCheckStatusInterval = function () {
    if (checkStatusInterval) {
      $interval.cancel(checkStatusInterval);
    }
  };
  $scope.$on('$destroy', $scope.cancelCheckStatusInterval);
  $scope.$watch('gridPanelScope.gridDataLoaded', function (newVal, oldVal) {
    if (gridPanel.reoptPreviewData.ndReopt && newVal === true && oldVal === false) {
      $scope.getReoptFlight();
    }
    if (gridPanel.jqxGridSettings.source && isFlightManagementGrid()) {
      $scope.onRowSelection();
    }
  });
};
GridNdReoptPreviewButtonController.$inject = ['$interval', '$scope', '$rootScope', 'Restangular', 'ReoptimizationService', 'FlightAnalysisGridService', 'MomentService', 'ScenarioService', 'ReoptimizationSaveService', 'ReoptPreviewDataUtilsService', 'SaveButtonUtilsService', 'FeatureToggleService'];
module.exports = GridNdReoptPreviewButtonController;